import { useState } from "react";
import { toast } from "sonner";
import { submitForm } from "../lib/api";

export function Field({ label, children, htmlFor }) {
  return (
    <div>
      <label htmlFor={htmlFor} className="field-label">
        {label}
      </label>
      {children}
    </div>
  );
}

export function useSubmission(formType, onSuccess) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async (payload) => {
    setSending(true);
    try {
      await submitForm({ form_type: formType, ...payload });
      setSent(true);
      toast.success("Received. A real person will read this and reply.");
      onSuccess?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Something went wrong — please try again.");
    } finally {
      setSending(false);
    }
  };

  return { sending, sent, setSent, send };
}

export function SubmitButton({ sending, children, testid, className = "btn-primary w-full" }) {
  return (
    <button type="submit" disabled={sending} className={className} data-testid={testid}>
      {sending ? "Sending…" : children}
    </button>
  );
}
